import React, { useCallback, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Login from '../../Views/Auth/Login';
import MainLayout from './Layout';
import { useDispatch, useSelector } from 'react-redux';
import { apiCall } from '../../API/RestApi';
import { UPDATE_MENU, UPDATE_USER } from '../../Redux/actions/userActions';

function ProtectedLayout() {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.user.token);
    const storedMenu = useSelector((state) => state.user.menu);
    const storedUser = useSelector((state) => state.user.user);
    const syncing = useRef(false);

    const refreshAccess = useCallback(async () => {
        if (!token || syncing.current) return;
        syncing.current = true;
        try {
            const res = await apiCall({
                method: 'GET',
                url: '/getusermenu',
                data: { headers: { Authorization: `Bearer ${token}` } },
            });
            if (res?.status !== 'success' || !res?.data) return;

            const nextMenu = JSON.stringify(res.data);
            if (nextMenu !== storedMenu) {
                dispatch(UPDATE_MENU(nextMenu));
            }

            try {
                const currentUser = JSON.parse(storedUser || '{}');
                const currentRole = JSON.stringify(currentUser?.user_role || {});
                if (currentRole !== nextMenu) {
                    currentUser.user_role = res.data;
                    currentUser.user_role_id = res.data.user_role_id;
                    dispatch(UPDATE_USER(JSON.stringify(currentUser)));
                }
            } catch (_) {
                // Menu tetap dapat diperbarui walaupun cache user lama tidak valid.
            }
        } finally {
            syncing.current = false;
        }
    }, [dispatch, storedMenu, storedUser, token]);

    useEffect(() => {
        if (!token) return undefined;
        refreshAccess();
        const interval = window.setInterval(refreshAccess, 15000);
        const onFocus = () => refreshAccess();
        const onVisibility = () => {
            if (document.visibilityState === 'visible') refreshAccess();
        };
        window.addEventListener('focus', onFocus);
        document.addEventListener('visibilitychange', onVisibility);
        return () => {
            window.clearInterval(interval);
            window.removeEventListener('focus', onFocus);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [refreshAccess, token]);

    if (token != null) return (<MainLayout><Outlet /></MainLayout>);
    return <Login />;
}

export default ProtectedLayout;
